/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';


export interface DwhQueryControllerSalesOfSolesMemberXlsx$Params {
  startYear: number;
  endYear: number;
}

export function dwhQueryControllerSalesOfSolesMemberXlsx(http: HttpClient, rootUrl: string, params: DwhQueryControllerSalesOfSolesMemberXlsx$Params, context?: HttpContext): Observable<StrictHttpResponse<Blob>> {
  const rb = new RequestBuilder(rootUrl, dwhQueryControllerSalesOfSolesMemberXlsx.PATH, 'get');
  if (params) {
    rb.query('startYear', params.startYear, {});
    rb.query('endYear', params.endYear, {});
  }

  return http.request(
    rb.build({ responseType: 'blob', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Blob>;
    })
  );
}

dwhQueryControllerSalesOfSolesMemberXlsx.PATH = '/api/dwh/query/sales-of-soles-member.xlsx';
